import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../types/types';
import { ICommentHOCProps } from './types';
import { getAuthUser } from '../../../../../../../store/model/authUser/selectors/getAuthUser';
import { ICommentLikesEvents, ICommentLikesFields } from '../../components/CommentLikes/types';
import { CommentLikes } from '../../components/CommentLikes/CommentLikes';
import { getCommentByIdCreateSelector } from './selectors/getCommentLikes';
import { showBoardLimitSnackbarIfNeeded } from '../../../../../aside_panel/effects/showBoardLimitSnackbarIfNeeded';
import { onLike } from '../events/onLike';

const mapStateToProps = () => {
    const getCommentLikes = getCommentByIdCreateSelector();

    const _mapStateToProps = (
        state: IApplicationState,
        { boardId, cardId, commentId, isReadonly }: ICommentHOCProps
    ): ICommentLikesFields => {
        return  {
            authUserPermissionId: getAuthUser(state).permissionId,
            commentId,
            likes: getCommentLikes(state, boardId, cardId, commentId),
            isReadonly
        };
    };

    return _mapStateToProps;
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId, cardId, commentId }: ICommentHOCProps
): ICommentLikesEvents => {
    return {
        onClick: () => dispatch(onLike(boardId, cardId, commentId)),
        onShowBoardLimitSnackbarIfNeeded: () => dispatch(showBoardLimitSnackbarIfNeeded()),
    };
};

export const CommentLikesHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CommentLikes);

CommentLikesHOC.displayName = 'CommentLikesHOC';
